"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaskedInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _input = require("@cian/ui-kit/input");
var _imask = _interopRequireDefault(require("imask"));
var React = _interopRequireWildcard(require("react"));
var _constants = require("./constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class MaskedInput extends React.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "maskRef", void 0);
    (0, _defineProperty2.default)(this, "handleAccept", () => {
      if (this.props.onAccept) {
        this.props.onAccept(this.maskValue);
      }
    });
    (0, _defineProperty2.default)(this, "handleComplete", () => {
      if (this.props.onComplete) {
        this.props.onComplete(this.maskValue);
      }
    });
  }
  get maskValue() {
    if (!this.maskRef) {
      return '';
    }
    return this.maskRef.unmaskedValue;
  }
  set maskValue(value) {
    if (!this.maskRef) {
      return;
    }
    this.maskRef.unmaskedValue = value;
  }
  componentDidMount() {
    if (!this.props.mask) {
      return;
    }
    this.initMask();
  }
  componentDidUpdate() {
    const {
      value
    } = this.props;
    const maskOptions = this.getMaskOptionsFromProps();
    if (maskOptions.mask) {
      if (this.maskRef) {
        this.maskRef.updateOptions(maskOptions);
        if (typeof value !== 'undefined' && (value !== this.maskValue || typeof value !== 'string' && this.maskRef.value === '') && !this.maskRef.el.isActive) {
          this.maskValue = value;
        }
      } else {
        this.initMask(maskOptions);
        if (value !== this.maskValue) {
          this.handleAccept();
        }
      }
    } else {
      this.destroyMask();

      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
      this.props.inputRef.current.value = value;
    }
  }
  componentWillUnmount() {
    this.destroyMask();
  }
  render() {
    return /*#__PURE__*/React.createElement(_input.Input, (0, _extends2.default)({
      inputRef: this.props.inputRef
    }, this.getNonMaskProps(), {
      defaultValue: this.props.value
    }));
  }
  initMask() {
    let maskOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getMaskOptionsFromProps();
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.maskRef = (0, _imask.default)(this.props.inputRef.current, maskOptions).on('accept', this.handleAccept).on('complete', this.handleComplete);
    this.maskValue = this.props.value || '';
  }
  destroyMask() {
    if (this.maskRef) {
      this.maskRef.destroy();
      delete this.maskRef;
    }
  }
  getMaskOptionsFromProps() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const availableOptions = Object.keys(this.props).filter(key => _constants.MASK_PROPS.includes(key));
    return availableOptions.reduce((accumulator, currentValue) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      accumulator[currentValue] = this.props[currentValue];
      return accumulator;
    }, {});
  }
  getNonMaskProps() {
    const availableOptions = Object.keys(this.props).filter(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    key => ![..._constants.MASK_PROPS, ..._constants.OWN_PROPS].includes(key));
    return availableOptions.reduce((accumulator, currentValue) => {
      accumulator[currentValue] = this.props[currentValue];
      return accumulator;
    }, {});
  }
}
exports.MaskedInput = MaskedInput;
(0, _defineProperty2.default)(MaskedInput, "defaultProps", {
  inputRef: /*#__PURE__*/React.createRef()
});